import { render, staticRenderFns } from "./index.vue?vue&type=template&id=27c8fdf4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\JH\\workspace\\r-UXDB4MFGGPNCQDCDVDHZHNGFNLKBT4K2FS26AFERI7RXVKAFNI2A\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c8fdf4')) {
      api.createRecord('27c8fdf4', component.options)
    } else {
      api.reload('27c8fdf4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=27c8fdf4&", function () {
      api.rerender('27c8fdf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "sources/series-display/index.vue"
export default component.exports